import type { UnknownOutputParams } from 'expo-router'
import type { ReactNode } from 'react'

import type { TGetCommunityApiData } from '../../../api/getCommunity.types'
import type { useCommunitySubscriptionsQuery } from '../../../services/useCommunitySubscriptionsQuery'
import { CommunityScreenLayout } from '../CommunityScreen/CommunityScreenLayout'
import { VirtusTodayPublication } from './VirtusTodayPublication'

type TVirtusCommunityScreenProps = {
  community: TGetCommunityApiData
  subscription: NonNullable<ReturnType<typeof useCommunitySubscriptionsQuery>['activeSubscription']>
  action?: string
  searchParams: UnknownOutputParams
}

const noop = () => {}

/**
 * Virtus journeys are followed live: instead of the full publications list,
 * the page only shows today's publication to members (the full list lives on CommunityPublicationsScreen).
 * Non-members see the classic community page.
 */
export const VirtusCommunityScreen = ({
  community,
  subscription,
  action,
  searchParams,
}: TVirtusCommunityScreenProps): ReactNode => (
  <CommunityScreenLayout
    id={community.id}
    action={action}
    searchParams={searchParams}
    community={community}
    subscription={subscription}
    listProps={{
      publications: [],
      isPending: false,
      isFetchingNextPage: false,
      hasNextPage: false,
      fetchNextPage: noop,
      ListEmptyComponent: <VirtusTodayPublication community={community} />,
    }}
  />
)
